import Quiz from "../../components/Quiz";

export default function App() {
  return (
    <div
      style={{
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
        padding: "2rem",
      }}
    >
      <Quiz />
    </div>
  );
}
